import { toRem } from '.';
import { Property } from 'csstype';
import styled from 'styled-components';


const remOr = (val?: string | number, orWhat: number | string = 'initial') => val !== undefined ? toRem(val) : orWhat;

export interface FillProps {
    flex?: 'row' | 'column';
    left?: number | string | 'initial';
    top?: number | string | 'initial';
    right?: number | string | 'initial';
    bottom?: number | string | 'initial';
    zIndex?: number | string | 'initial';
    overflow?: Property.Overflow;
    pointerEvents?: Property.PointerEvents;
}

export const Fill = styled.div<FillProps>`
    position: absolute;
    display: ${p => p.flex ? 'flex' : 'block'};
    flex-direction: ${p => p.flex};
    left: ${p => p.left === 'initial' ? 'initial' : remOr(p.left, '0')};
    top: ${p => p.top === 'initial' ? 'initial' : remOr(p.top, '0')};
    right: ${p => p.right === 'initial' ? 'initial' : remOr(p.right, '0')};
    bottom: ${p => p.bottom === 'initial' ? 'initial' : remOr(p.bottom, '0')};
    z-index: ${p => p.zIndex === 'initial' ? 'initial' : p.zIndex};
    pointer-events: ${p => p.pointerEvents ?? 'initial'};
    overflow: ${p => p.overflow ?? 'initial'};
`;
